<h3>{{ title }}</h3>
<h5 *ngIf="description">{{ description }}</h5>

<span *ngIf="canScrollLeft" (click)="scrollLeft()" class="scroll scroll-left">
  <img alt src="/assets/images/chevron-left.svg" />
</span>
<span
  *ngIf="canScrollRight"
  (click)="scrollRight()"
  class="scroll scroll-right">
  <img alt src="/assets/images/chevron-right.svg" />
</span>

<div class="idea-cards d-flex gap-2" (scroll)="handleScroll()" #scrollpane>
  <app-idea-card
    *ngFor="let idea of ideas"
    (click)="openIdeaModal(idea)"
    [idea]="idea"
    [session]="idea.session"
    [showTopic]="true"
    [small]="true"></app-idea-card>
  <span *ngIf="!ideas || ideas.length === 0" class="empty not-mobile">
    <img alt src="/assets/images/empty-row.svg" />
    <span [innerHTML]="emptyMessage"></span>
  </span>

  <span *ngIf="!ideas || ideas.length === 0" class="empty mobile-only">
    <img alt src="/assets/images/empty-row.svg" />
    <span [innerHTML]="emptyMessage"></span>
  </span>
</div>
